export class Documents {
  typeId
  type
  name
  documents

  constructor(documents = {}) {
    this.typeId = documents.typeId ? String(documents.typeId) : ''
    this.type = documents.type ? String(documents.type) : ''
    this.name = documents.name ? String(documents.name) : ''
    this.documents = documents.documents ? [...documents.documents] : []

  }
}